<template>
  <div class="modal fade" id="add-card-modal" aria-hidden="false" aria-labelledby="exampleGrid" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <form autocomplete="off" id="billingInfoForm" @submit.prevent="submitCheckout()">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-12">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#add-card-modal')">
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group form-material">
                  <div class="form-group form-material">
                    <label class="control-label" for="card-number-data">
                      {{ $t("account.settings.credit_card.card_number") }}
                    </label>
                    <input type="text"
                           data-stripe="number"
                           pattern="4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11}"
                           class="form-control"
                           id="card-number-data"
                           name="card-number"
                           required />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group form-material">
                      <div class="form-group form-material">
                        <label class="control-label" for="card-cvc-data">
                          {{ $t("account.settings.credit_card.card_cvc") }}
                        </label>
                        <input type="text"
                               pattern="^\d{3,4}$"
                               minlength="3"
                               maxlength="3"
                               size="5"
                               data-stripe="cvc"
                               class="form-control"
                               id="card-cvc-data"
                               name="card-cvc"
                               required />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group form-material" style="flex-grow: 1.2;">
                      <input type="hidden" id="exp_month" size="2" data-stripe="exp_month">
                      <input type="hidden" id="exp_year" size="2" data-stripe="exp_year">
                      <label for="card-expiration-data">{{ $t("account.settings.credit_card.card_expiration") }}</label>
                      <input type="text"
                             class="form-control"
                             maxlength="7"
                             pattern="^\d{1,2}\s?\/\s?\d{1,4}$"
                             id="card-expiration-data"
                             placeholder="MM/AA"
                             required />
                    </div>
                  </div>
                  <div v-if="planId" class="col-12">
                    <label> {{ $t("billing_modal.number_subscription_text") }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button type="submit" :disabled="submitButtonDisabled" class="btn btn-primary waves-effect waves-classic btn-save">
              {{ $t("account.settings.credit_card.change") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>


</template>

<script>
    import subscriptionService from '../../services/subscription';
    import accountService from '../../services/account';
    import mixin from '../../mixins/mixin';

    export default {
      name: 'billing-modal',
      data() {
        return {
          submitButtonDisabled: false,
          activateButtonDisabled: false,
          paymentIntent: null,
        };
      },
      mixins: [mixin],
      props: [
        'planId',
        'rentalId',
      ],
      components: {
        VLoading: require('components/loading/loading.vue'),
      },
      mounted() {
        $('#card-expiration-data').on('input', function () {
          let val = String($(this).val());
          val = val.replace(/[^0-9\/ ]/g, '');

          if (val.length === 1 && parseInt(val) > 1 ||
            val.length === 2 && val.charAt(1) === '/' ||
            val.length === 2 && val.charAt(1) === ' ') {
            val = `0${parseInt(val)} / `;
          } else if (val.length === 2 && parseInt(val) === 1) {
            val = '01' + ' / ';
          } else if (val.length === 2 && parseInt(val) === 0) {
            val = '0';
          } else if (val.length === 2 && parseInt(val) <= 12) {
            val += ' / ';
          } else if (val.length === 2 && parseInt(val) > 12) {
            val = val.substring(val.length - 2, val.length - 1);
          } else if (val.length === 4) {
            val = val.substring(0, 1);
          } else if (val.length > 4) {
            const before = val.substring(0, 5);
            let after = val.substring(5, val.length);
            after = after.replace(/[\/ ]/g, '');
            val = before + after;
          }
          $(this).val(val);
        });
      },
      methods: {
        async submitCheckout() {
          this.submitButtonDisabled = true;
          await accountService.getStripeKey(this);
          const exp = $('#card-expiration-data').val();
          const e = exp.split('/');
          $('#exp_month').val(e[0].replace(' ', ''));
          $('#exp_year').val(e[1].replace(' ', ''));

          const form = {
            number: $('#card-number-data').val(),
            cvc: $('#card-cvc-data').val(),
            exp_month:   $('#exp_month').val(),
            exp_year:  $('#exp_year').val(),
          };
          await Stripe.card.createToken(form, this.stripeResponseHandler);
        },

        async stripeResponseHandler(status, response) {
          if (response.error) {
            let text = '';
            if (response.error.message.match(/A network error has occurred/)) {
              text = this.$t('payments.permalink.errors.network_error');
            } else if (response.error.message.match(/Your card number is incorrect/)) {
              text = this.$t('payments.permalink.errors.card_number_incorrect');
            } else if (response.error.message.match(/Expired API Key/)) {
              text = this.$t('payments.permalink.errors.expired_api_key');
            } else if (response.error.message.match(/Your card's expiration year is invalid/)) {
              text = this.$t('payments.permalink.errors.exp_year');
            } else {
              text = this.$t('payments.permalink.errors.contact_support');
            }

            // showing error message
            toastr.error(text);
            this.submitButtonDisabled = false;
          } else {
            this.stripeToken = response.id;
            const data = {
              stripe_token: response.id,
              card_brand: response.card.brand,
              card_last_four: response.card.last4,
              stripe_card_id: response.card.id,
            };

            await subscriptionService.updateSource(this, data);
            await subscriptionService.activateSubscription(this, this.planId, this.rentalId);
            // if (this.paymentIntent)
            //   Stripe.confirmCardPayment(this.paymentIntent.client_secret);
            
            this.submitButtonDisabled = false;
          }
        },
      },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// billing-modal.vue?591175be